import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ offset: number }>()(
  (theme, { offset }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
      marginTop: theme.spacing(3),
    },
    scrollTopMargin: {
      scrollMarginTop: `${offset}px`,
      gap: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
    },
    rowWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    tableSubHeading: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: theme.palette.labraText.description,
    },
  })
)
